import { render, staticRenderFns } from "./addEdit.vue?vue&type=template&id=3525e7f4&"
import script from "./addEdit.vue?vue&type=script&lang=js&"
export * from "./addEdit.vue?vue&type=script&lang=js&"
import style0 from "./addEdit.vue?vue&type=style&index=0&id=3525e7f4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports